<h2 mat-dialog-title class="mb-3">Delete All Prompts</h2>
<mat-dialog-content class="mat-typography">
    <p>Are you sure you want to delete <strong>all {{ totalPrompts }} prompt{{ totalPrompts === 1 ? '' : 's' }}</strong> from <strong>"{{ data.promptSetName }}"</strong>?</p>
    <p>The prompt set itself, its output schema, and published status will be preserved. Only the prompts will be removed.</p>
    <mat-form-field appearance="outline" style="width: 100%; margin-top: 8px;">
        <mat-label>Type DELETE to confirm</mat-label>
        <input matInput [(ngModel)]="confirmText" placeholder="DELETE" autocomplete="off" [disabled]="isSubmitting" />
    </mat-form-field>
    <p *ngIf="isSubmitting" style="color: rgba(0,0,0,0.6); font-size: 13px;">
        Deleting... {{ deletedCount }} of {{ totalPrompts }} completed.
    </p>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close class="cancel-button" (click)="cancel()" [disabled]="isSubmitting">Cancel</button>
    <button mat-raised-button color="warn" (click)="deleteAllPrompts()" class="delete-button" [disabled]="!isDeleteConfirmed || isSubmitting">
        Delete All
        <mat-spinner *ngIf="isSubmitting" diameter="20" class="button-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>
